import React from "react";
import {
  VerifiedInputDiv,
  StyledVerifiedInput,
  Wrapper,
  FlagDiv
} from "./verified-input.styles";
import { Label } from "../label/label";
import { IndoFlag } from "components/icons/indo-flag";
import { VerifiedInputProps } from "./verified-input.types";

const VerifiedInput = ({
  label,
  name,
  defaultValue
}: VerifiedInputProps): JSX.Element => {
  return (
    <VerifiedInputDiv>
      <Label id={name}>{label}</Label>
      <Wrapper>
        <span>
          <FlagDiv>
            <IndoFlag /> +62
          </FlagDiv>
        </span>
        <StyledVerifiedInput disabled defaultValue={defaultValue} />
      </Wrapper>
    </VerifiedInputDiv>
  );
};

export { VerifiedInput };
